import { render, staticRenderFns } from "./incomeResultItem.vue?vue&type=template&id=3d056da4&"
import script from "./incomeResultItem.vue?vue&type=script&lang=js&"
export * from "./incomeResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports